import { render, staticRenderFns } from "./qrCodeSquare.vue?vue&type=template&id=2526c38c&scoped=true"
import script from "./qrCodeSquare.vue?vue&type=script&lang=js"
export * from "./qrCodeSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2526c38c",
  null
  
)

export default component.exports